export const CONTINENTAL_US_BOUNDS: {
  center: [number, number]
  northEast: [number, number]
  southWest: [number, number]
} = {
  center: [-98.4079974, 40.5488317],
  northEast: [-66.9513812, 49.3457868],
  southWest: [-124.7844079, 24.7433195],
}
